import '../applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedReviewStatusView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  name: 'review_status'
  alias: 'Review Status'
  humanize: true
  unmodifiableByModerators: true

  removeFilter: (value) ->
    @searchQuery.removeReviewStatus(value)